const K = 1024;

export const ONE_MB = K * K;

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(K));

  return parseFloat((bytes / Math.pow(K, i)).toFixed(dm)) + ' ' + sizes[i];
};
